export const credenciales = {mapsKey: 'AIzaSyBPCNffIKxICL3MPaRVHAO_RMl3Fplb-hc'}